<template>
  <el-form
    status-icon
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    label-width="120px"
    v-loading="loading"
    class="carpo-form demo-ruleForm"
  >
    <Notice
      v-if="
        ruleForm.remaining_quota_capacity &&
        (this.$route.name.includes('VIEW') || this.$route.name.includes('EDIT'))
      "
      class="mb-8 col-span-full"
    >
      ظرفیت سهمیه باقی مانده:
      <b>{{ ruleForm.remaining_quota_capacity }}</b> لیتر
    </Notice>
    <el-form-item :label="$t('TITLE')" prop="title">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        v-model="ruleForm.title"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <el-form-item
      :label="$t('SERIALNUMBER')"
      prop="serial_number"
      class="lg:col-span-2 ltr"
    >
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        @input="
          ruleForm.serial_number = numberWithSpaces(
            toEnglish(ruleForm.serial_number, false)
          )
        "
        v-model="ruleForm.serial_number"
        autocomplete="off"
      ></el-input>
    </el-form-item>

    <el-switch
      :disabled="ruleForm.disabled"
      v-model="ruleForm.is_active"
      active-color="#13ce66"
      inactive-color="#ff4949"
      :active-text="$t('ACTIVE')"
      :inactive-text="$t('INACTIVE')"
    >
    </el-switch>

    <!-- <div class="lg:col-span-1 hidden lg:flex"></div> -->

    <el-form-item :label="$t('PASSWORD')" prop="password" class="ltr">
      <el-input
        :disabled="ruleForm.disabled"
        type="text"
        @input="ruleForm.password = toEnglish(ruleForm.password)"
        v-model="ruleForm.password"
        autocomplete="off"
      ></el-input>
    </el-form-item>

    <el-form-item
      :label="$t('quota_capacity_during_add')"
      prop="quota_capacity_during_add"
    >
      <el-input-number
        :disabled="ruleForm.disabled"
        v-model="ruleForm.quota_capacity_during_add"
        :step="10"
        :min="0"
      ></el-input-number>
    </el-form-item>

    <el-form-item
      :label="$t('TYPE')"
      prop="type.id"
      v-loading="fuelTypeLoading"
    >
      <el-select
        :disabled="ruleForm.disabled"
        :placeholder="$t('SELECT_PLACEHOLDER')"
        :collapse-tags="!ruleForm.disabled"
        clearable
        filterable
        v-model="ruleForm.type.id"
      >
        <el-option
          v-for="item in fuelTypes"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <VehicleSelect
      prop="company_vehicle.id"
      :model="ruleForm.company_vehicle.id"
      @update="ruleForm.company_vehicle.id = $event"
      :disabled="ruleForm.disabled"
    />

    <el-form-item
      class="col-span-full mt-8"
      :label="$t('description')"
      prop="description"
    >
      <el-input
        :disabled="ruleForm.disabled"
        type="textarea"
        v-model="ruleForm.description"
      ></el-input>
    </el-form-item>

    <FormConfirmation
      v-show="!ruleForm.disabled"
      @resetForm="resetForm('ruleForm')"
      @submitForm="submitForm('ruleForm')"
      :edit="null"
      :loading="submitLoading"
    />
  </el-form>
</template>
<script>
import { resetForm } from '@/mixins/resetForm'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
// import { carsListSummary } from '@/api/cars'
import { fuelType, addFuel, editFuel } from '@/api/fuel'
import VehicleSelect from '@/components/elements/vehiclesSelect.vue'
import { numberWithSpaces } from '@/mixins/numberWithSpaces'
import { getFuel } from '@/api/fuel'
import Notice from '@/components/elements/notice'

export default {
  mixins: [resetForm, numberWithSpaces],
  props: {
    fuel: {
      type: Object,
      required: false,
    },
  },
  components: {
    FormConfirmation,
    VehicleSelect,
    Notice,
  },
  data() {
    return {
      carsLoading: false,
      submitLoading: false,
      fuelTypes: [],
      fuelTypeLoading: true,
      loading: false,
      list: [],
      ruleForm: {
        description: '',
        remaining_quota_capacity: '',
        serial_number: '',
        company_vehicle: {
          id: '',
        },
        type: {
          id: '',
        },
        title: '',
        password: '',
        is_active: true,
        free_capacity: '',
        quota_capacity_during_add: '',
      },
      rules: {
        company_vehicle: {
          id: [
            {
              required: true,
              message: this.$i18n.t('REQUIRED_CHOOSE', {
                type: this.$i18n.t('VEHICLE_TITLE'),
              }),
              trigger: 'blur',
            },
          ],
        },
        type: {
          id: [
            {
              required: true,
              message: this.$i18n.t('REQUIRED_CHOOSE', {
                type: this.$i18n.t('TYPE'),
              }),
              trigger: 'blur',
            },
          ],
        },
        password: {
          required: true,
          message: this.$i18n.t('REQUIRED_FIELD', {
            type: this.$i18n.t('PASSWORD'),
          }),
          trigger: 'blur',
        },

        quota_capacity_during_add: {
          required: true,
          message: this.$i18n.t('REQUIRED_FIELD', {
            type: this.$i18n.t('quota_capacity_during_add'),
          }),
          trigger: 'blur',
        },
        serial_number: {
          required: true,
          message: this.$i18n.t('REQUIRED_FIELD', {
            type: this.$i18n.t('SERIALNUMBER'),
          }),
          trigger: 'blur',
        },
      },
    }
  },
  watch: {
    fuel(val) {
      this.ruleForm = val
      this.ruleForm.serial_number = this.numberWithSpaces(val.serial_number)
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const actionPayload = {
            description: this.ruleForm.description,
            id: this.$route.params.id,
            serial_number: this.ruleForm.serial_number.replace(/\s/g, ''),
            password: this.ruleForm.password,
            free_capacity: this.ruleForm.free_capacity,
            quota_capacity_during_add: this.ruleForm.quota_capacity_during_add,
            type: this.ruleForm.type.id,
            is_active: this.ruleForm.is_active,
            company_vehicle: this.ruleForm.company_vehicle.id,
            title: this.ruleForm.title,
          }

          var dispatchFunc = this.$route.params.id == null ? addFuel : editFuel
          this.submitLoading = true
          dispatchFunc.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.$notify.success({
                title:
                  this.$t(this.$route.name) +
                  ' ' +
                  this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg',
              })
              this.$router.push({
                name: 'FUEL_LIST',
              })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  created() {
    // carsListSummary.api().then((res) => {
    //   if (res) {
    //     this.list = res
    //     this.carsLoading = false
    //   }
    // })
    fuelType.api().then((res) => {
      if (res) {
        this.fuelTypes = res
        this.fuelTypeLoading = false
      }
    })
    if (this.$route.params.id) {
      this.loading = true
      getFuel.api(this.$route.params.id).then((res) => {
        this.loading = false
        const fuel = {
          ...res,
          id: this.$route.params.id,
          disabled: this.$route.name.includes('VIEW') ? true : false,
        }
        this.ruleForm = fuel
      })
    }
  },
}
</script>
